import { useMount } from '@cutwise/react-utils';

import { navigateTo } from '@/common/helpers/navigateTo';

interface RedirectPageProps {
  to: string;
}

function RedirectPage(props: RedirectPageProps) {
  const { to } = props;

  useMount(() => {
    navigateTo(to);
  });

  return null;
}

export default RedirectPage;
